import clsx from "clsx";
import { useId } from "react";

interface IconProps {
  size?: number;
  className?: string;
}

function ConfluenceIcon({ size = 24, className }: Readonly<IconProps>) {
  const uid = useId();
  const grad1 = `confluence-g1-${uid}`;
  const grad2 = `confluence-g2-${uid}`;

  return (
    <svg
      role="img"
      aria-label="Confluence logo"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      className={clsx(className)}
    >
      <defs>
        <linearGradient
          id={grad1}
          x1="99.14%"
          y1="112.71%"
          x2="33.86%"
          y2="37.75%"
        >
          <stop offset="18%" stopColor="#0052CC" />
          <stop offset="100%" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id={grad2}
          x1="0.93%"
          y1="-12.58%"
          x2="66.18%"
          y2="62.31%"
        >
          <stop offset="18%" stopColor="#0052CC" />
          <stop offset="100%" stopColor="#2684FF" />
        </linearGradient>
      </defs>

      <g fillRule="nonzero">
        <path
          d="M9.26 187.33c-2.64 4.31-5.61 9.31-8.13 13.29-2.26 3.81.96 8.72 4.72 11.05l52.82 32.51a9.06 9.06 0 0 0 6.21.98 9.02 9.02 0 0 0 5.05-3.74c2.11-3.54 4.83-8.13 7.8-13.04 20.93-34.54 41.97-30.32 79.93-12.19l52.38 24.91a9.05 9.05 0 0 0 6.32-.72 9 9 0 0 0 4.61-5.34l25.15-56.89c1.78-4.06-.03-8.8-4.06-10.65-11.05-5.2-33.04-15.56-52.82-25.11C118.13 109.8 57.62 112.04 9.26 187.33Z"
          fill={`url(#${grad1})`}
        />
        <path
          d="M246.12 58.23c2.64-4.31 5.61-9.31 8.13-13.29 2.25-3.81-.96-8.72-4.72-11.05L196.7 1.39a9.05 9.05 0 0 0-6.37-1.18 9.02 9.02 0 0 0-5.21 3.86c-2.11 3.54-4.83 8.13-7.8 13.04-20.93 34.54-41.97 30.32-79.93 12.19L47.18 4.52a9.06 9.06 0 0 0-6.32.72 9 9 0 0 0-4.61 5.34L11.09 65.46c-1.78 4.06.03 8.8 4.06 10.65 11.05 5.2 33.04 15.56 52.82 25.11 71.35 34.54 131.85 32.22 178.14-43.99Z"
          fill={`url(#${grad2})`}
        />
      </g>
    </svg>
  );
}

export { ConfluenceIcon };